import {Storage} from "@/services/Storage";
import axios from "axios";
import router from "@/router";
import TimeManager from "@/services/TimeManager";

export default {
    name: 'billing',
    state: {
        daysToExpire: 30
    },
    getters: {
        getDaysToExpire: (state) => state.daysToExpire,
    },
    mutations: {
        setDaysToExpire: (state, data) => {
            state.daysToExpire = data;
            // console.trace("Mutation called from here:");
        },    },
    actions: {
        getExpiryDateByCustomerID: async (context) => {
            let hideCancel = false;
            let registrationDetails = context.getters.getRegistrationDetails;
            if (!registrationDetails || !registrationDetails.Expire) {
                console.log("No registration details or expiry date available");
                return;
            }

            if(router.currentRoute?.path === '/login'){
                hideCancel = true
            }

            let Expire = registrationDetails.Expire;
            let diffDays = TimeManager.getDateDiff(TimeManager.getNow(), Expire);

            context.commit('setDaysToExpire', diffDays);
            console.log("Days to Expire:", context.getters.getDaysToExpire);
            
            if (diffDays <= 0) {
                context.commit('setDaysToExpire', 0);
                if(router.currentRoute.name !== 'system-expired' && router.currentRoute.name !== 'make-subscription-payment' && router.currentRoute.name !== 'kazangOnline'){
                    return Swal.fire({
                        title: `System Expired!`,
                        icon: 'error',
                        html: '<p>Please make payment to continue</p>',
                        showCancelButton: !hideCancel,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: 'Proceed to Pay',
                        cancelButtonText: 'Logout of store',
                        showLoaderOnConfirm: true,
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            try {
                                await router.push({name: 'system-expired'});
                            } catch (e) {
                                console.error("Error", e)
                            }
                        } else if (result.dismiss === Swal.DismissReason.cancel) {
                            await context.dispatch('signOutOfStore');
                            await context.dispatch('posLogout');
                        }
                    });
                }
            }
        },
        getCustomerBalance: async (context) => {
            let registrationDetails = context.getters.getRegistrationDetails;
            let customerID = registrationDetails.id;
            console.log({customerID})
            if (!customerID) return;
            return axios.get(subscriptionApiGET, {
                params: {
                    route: `adminCustomerPanel/getBalance?customer=` + customerID
                }
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        hasOverdueCount: async (context) => {
            let registrationDetails = context.getters.getRegistrationDetails;
            let customerID = registrationDetails.id;
            if (!customerID) return;
            return axios.get(subscriptionApiGET, {
                params: {
                    route: `adminCustomerPanel/hasOverdueCount?customer=` + customerID
                }
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        getDueInvoices: async (context) => {
            let registrationDetails = context.getters.getRegistrationDetails;
            let customerID = registrationDetails.id;
            if (!customerID) return;
            return axios.get(subscriptionApiGET, {
                params: {
                    route: `adminCustomerPanel/getDueInvoice?customer=` + customerID
                }
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        getActiveStores: async (context) => {
            let registrationDetails = context.getters.getRegistrationDetails;
            let customerID = registrationDetails.id;
            if (!customerID) return;
            return axios.get(subscriptionApiGET, {
                params: {
                    route: `adminCustomerPanel/getActiveStores?customer=` + customerID
                }
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },

        getCustomerQuotes: async (context) => {
            let registrationDetails = context.getters.getRegistrationDetails;
            let customerID = registrationDetails.id;
            if (!customerID) return;
            return axios.get(subscriptionApiGET, {
                params: {
                    route: `adminCustomerPanel/getQuotes?customer=` + customerID
                }
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },
        makeKazangLicensePayment: async (context, payload) => {
            let invoiceReference = payload.invoiceReference;
            // let url = `http://localhost:8181/kazangApi/api/paymentGateWay/makeAndProcessPayment`;
            let url = `https://lna.abc.co.zm/kazangApi/api/paymentGateWay/makeAndProcessPayment`;
            return axios.post(url, payload, {timeout: 1000 * 2 * 60})
                .then(() => {
                    return axios.get(subscriptionApiGET, {
                        params: {
                            route: `paymentCompleted/kazangProcess/${invoiceReference}`
                        }
                    }).then(() => context.dispatch(`getExpiryDateByCustomerID`)).catch(err => {
                        throw new Error(err.response)
                    })
                }).catch(err => errorHandler.tomcatError(err));

        },

        makeVCDLicensePayment: async (context, invoiceReference) => {
            return axios.get(subscriptionApiGET, {
                params: {
                    route: `paymentCompleted/kazangProcessVCD/${invoiceReference}`
                }
            }).then(() => context.dispatch(`getExpiryDateByCustomerID`)).catch(err => errorHandler.tomcatError(err));
        },

    }
}
